// apps/client/src/pages/error/ServerErrorPage.tsx
import { useNavigate } from "react-router-dom";
import { Truck } from "lucide-react";

export default function ServerErrorPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-50 flex items-center justify-center p-4">
      <div className="text-center w-full max-w-sm">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-600 rounded-2xl mb-6 shadow-lg">
          <Truck className="w-9 h-9 text-white" />
        </div>
        <p className="text-8xl font-black text-gray-200 mb-4 select-none">
          500
        </p>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Server Error</h1>
        <p className="text-gray-500 mb-8 mx-auto">
          Something went wrong on our end. Our team has been notified. Please
          try again in a few moments.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="min-h-[44px] px-6 py-3 rounded-lg border-2 border-red-600 text-red-600 font-semibold text-sm hover:bg-red-50 transition-colors"
          >
            ↺ Try Again
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="min-h-[44px] px-6 py-3 rounded-lg bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-colors"
          >
            Back to Dashboard
          </button>
        </div>
        <p className="mt-8 text-xs text-gray-400">
          Error code: 500 — Internal Server Error
        </p>
      </div>
    </div>
  );
}

// Day 59 complete
